module.exports = __webpack_public_path__ + "static/media/nodeGetPost.770b7e12.png";